<template>
  <div class="keyword">
    <div class="input-container">
      <label>Keyword Density Test</label>
      <input class="input" autocomplete="off" v-model="keyword" />
    </div>
    <span>{{ density }}%</span>
  </div>
</template>

<script>
import sharedWordCountScript from '@/assets/shared-scripts/wordcount'
import sharedConvertScript from '@/assets/shared-scripts/convert'
export default {
  created() {
    this.contentWordCount = sharedWordCountScript.contentWordCount
    this.contentObjectToString = sharedConvertScript.contentObjectToString
  },
  props: {
    content: Object,
  },
  data() {
    return {
      keyword: '',
    }
  },
  computed: {
    trimmedContent() {
      return this.contentObjectToString(this.content)
        .trim()
        .toLowerCase()
    },
    wordCount() {
      return this.contentWordCount(this.content)
    },
    count() {
      return this.keyword.length > 0 ? this.trimmedContent.split(this.keyword.toLowerCase()).length - 1 : 0
    },
    density() {
      const density = (this.count / this.wordCount) * 100 ? (this.count / this.wordCount) * 100 : 0
      return density.toFixed(2)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/shared-styles/input.scss';

.keyword {
  display: flex;
  align-items: center;
  padding: 1.5rem;
  span {
    margin-top: 0.75rem;
    margin-left: 0.5rem;
    font-size: 0.875rem;
  }
}
</style>
